import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { EVENTS, DEFAULT_STATE } from './constants';

class CategoriesFilterTagsStore extends EventDrivenStore {
  constructor() {
    console.log('[CategoriesFilterTagsStore] Initializing CategoriesFilterTagsStore');
    super('categoriesFilterTags', DEFAULT_STATE);

    this.setupEvents();
    console.log('[CategoriesFilterTagsStore] CategoriesFilterTagsStore initialized successfully');
  }

  setupEvents() {
    console.log('[CategoriesFilterTagsStore] Setting up event listeners');

    // Écouter les événements de sélection/désélection de catégories
    this.on(EVENTS.CATEGORIES_FILTER_TAGS.CATEGORY_SELECTED, (categoryId) => {
      console.log('[CategoriesFilterTagsStore] CATEGORY_SELECTED event received for category:', categoryId);

      if (!this.state.selectedCategories.includes(categoryId)) {
        this.state.selectedCategories.push(categoryId);
        this.updateFilters();
        console.log('[CategoriesFilterTagsStore] Category selected:', {
          categoryId,
          selectedCategories: this.state.selectedCategories
        });
      }
    });

    this.on(EVENTS.CATEGORIES_FILTER_TAGS.CATEGORY_DESELECTED, (categoryId) => {
      console.log('[CategoriesFilterTagsStore] CATEGORY_DESELECTED event received for category:', categoryId);

      const index = this.state.selectedCategories.indexOf(categoryId);
      if (index > -1) {
        this.state.selectedCategories.splice(index, 1);
        this.updateFilters();
        console.log('[CategoriesFilterTagsStore] Category deselected:', {
          categoryId,
          selectedCategories: this.state.selectedCategories
        });
      }
    });

    // Écouter l'événement de réinitialisation
    this.on('categories_filter_tags.reset_filters', () => {
      console.log('[CategoriesFilterTagsStore] Reset filters event received');
      this.resetFilters();
    });

    console.log('[CategoriesFilterTagsStore] All event listeners set up successfully');
  }

  updateFilters() {
    console.log('[CategoriesFilterTagsStore] Updating filters');

    // Mettre à jour l'objet filters avec les catégories sélectionnées
    this.state.filters = {
      categories: [...this.state.selectedCategories],
      hasCategories: this.state.selectedCategories.length > 0
    };

    // Émettre l'événement FILTERS_UPDATED
    this.emit(EVENTS.CATEGORIES_FILTER_TAGS.FILTERS_UPDATED, this.state.filters);
    console.log('[CategoriesFilterTagsStore] Filters updated and emitted:', this.state.filters);
  }

  // Getter pour vérifier si des filtres actifs existent
  get hasActiveFilters() {
    return this.state.selectedCategories.length > 0;
  }

  // Méthode pour obtenir les catégories sélectionnées
  getSelectedCategories() {
    return this.state.selectedCategories;
  }

  // Méthode pour obtenir les filtres actifs
  getActiveFilters() {
    return this.state.filters;
  }

  // Méthode pour réinitialiser les filtres
  resetFilters() {
    console.log('[CategoriesFilterTagsStore] Resetting filters');
    this.state.selectedCategories = [];
    this.updateFilters();
  }
}

export default CategoriesFilterTagsStore;